const { BaseStorage } = require("@/storage/BaseStorage");

const storageKey = "of-colibri-config";

const eventKey = `${storageKey}:changed`;

export class ColibriTableConfiguration {
  /**
   *
   * @param {Object} options - Opções de configuração
   * @param {string} options.externalId - Id da mesa ou comanda
   * @param {string} options.host - Host da API
   * @param {string} options.port - Porta da API
   * @param {string} options.user - Usuário da API
   * @param {string} options.password - Senha da API
   * @param {string} options.callWaiterSku - SKU do produto (Chamar garçom)
   * @param {boolean} options.allowExplodeCombination - Enviar combo como itens avulsos
   * @param {BaseStorage} options.storage - Instância do serviço de armazenamento
   */

  constructor({ externalId, host, port, user, password, callWaiterSku, allowExplodeCombination, storage }) {
    /**
     * Id da mesa ou comanda
     * @type {string}
     */
    this.externalId = externalId;

    /**
     * Host da API
     * @type {string}
     */
    this.host = host;

    /**
     * Porta da API
     * @type {string}
     */
    this.port = port;

    /**
     * Usuário da API
     * @type {string}
     */
    this.user = user;

    /**
     * Senha da API
     * @type {string}
     */
    this.password = password;

    /**
     * SKU do produto (Chamar garçom)
     * @type {string}
     */
    this.callWaiterSku = callWaiterSku;

    /**
     * Enviar combo como itens avulsos
     * @type {boolean}
     */
    this.allowExplodeCombination = allowExplodeCombination;

    /**
     * Instancia do serviço de armazenamento.
     * @type {BaseStorage}
     */
    this.storage = storage;
  }

  static fromStorage() {
    const storage = new BaseStorage({ key: storageKey });

    const configs = storage.getData();

    const tableConfiguration = new ColibriTableConfiguration({
      ...configs,
      storage,
    });

    tableConfiguration.updateStatus();

    return tableConfiguration;
  }

  update(configs) {
    const currentKeys = Object.keys(this);
    const updatedKeys = Object.keys(configs || {});

    for (const field of currentKeys) {
      this[field] = updatedKeys.includes(field) ? configs[field] : this[field];
    }

    this.updateStatus();

    if (window) {
      this.storage.setData(this);

      window.dispatchEvent(
        new CustomEvent(eventKey, {
          detail: { storage: this.storage.id, key: this.storage.getKey() },
        })
      );
    }
  }

  addListener(handler) {
    if (!this.listener) {
      this.listener = (event) => {
        if (event.detail.key === this.storage.getKey()) {
          handler();
        }
      };
      window.addEventListener(eventKey, this.listener);
    }
  }

  removeListener() {
    if (this.listener) {
      window.removeEventListener(eventKey, this.listener);
      this.listener = null;
    }
  }

  export() {
    const { storage, listener, ...configs } = this;
    return { ...configs };
  }

  isConfigured() {
    return !!(this.externalId && this.host && this.port && this.user && this.password);
  }

  updateStatus() {
    this.configured = this.isConfigured();
  }
}
